import { Padding } from "@mui/icons-material";

export const mainCont = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  overflow: "hidden",
  mb: 20,
  px: "15px",
  pb: "15px",
};

export const headerCont = {
  //height: "64px",
  pb: "15px",
  width: "100%",
  alignItems: "start",
  justifyItems: "start",
  pt: { mobile: 2, tablet: 2 },
};

export const emptyCont = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const paginationCont = {
  boxShadow:
    "0px 8px 12px rgba(0, 0, 0, 0.1), 0px 0px 24px rgba(0, 0, 0, 0.08)",
  height: "44px",
  width: "100%",
  marginTop: "10px",
  borderBottomRightRadius: "12px",
  borderBottomLeftRadius: "12px",
  display: "flex",
  flexDirection: "row",
  justifyContent: { mobile: "flex-start", tablet: "center" },
  alignItems: "center",
  position: "relative",
};

export const table = {
  title: {
    color: "primary.main",
    fontWeight: 500,
    fontSize: "18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    my: "10px",
  },
};
